module.exports = __webpack_public_path__ + "static/media/galerija_2022_0002.000d63e9.jpg";